// Bare 'constants' collides with Node's built-in module in TS resolution;
// the 'constants/index' subpath hits the path mapping and resolves identically at runtime.
import * as Constants from 'constants/index';

interface UserFilterState {
  filterByStatus: string;
  filterByValue: string;
}

// Action fields are read off a loosely-typed action at the reducer boundary;
// dispatchers live in untyped .js and always carry the relevant field.
interface UserFilterAction {
  type: string;
  filterByStatus: string;
  filterByValue: string;
}

const initialState: UserFilterState = {
  filterByStatus: '',
  filterByValue: '',
};

export function UserFilterReducer(
  state: UserFilterState = initialState,
  action: UserFilterAction,
): UserFilterState {
  switch (action.type) {
    case Constants.CloudAdmin.USER_FILTER.FILTER_BY_STATUS:
      return { ...state, filterByStatus: action.filterByStatus };
    case Constants.CloudAdmin.USER_FILTER.CLEAR_FILTER_BY_STATUS:
      return { ...state, filterByStatus: '' };
    case Constants.CloudAdmin.USER_FILTER.FILTER_BY_VALUE:
      return { ...state, filterByValue: action.filterByValue };
    case Constants.CloudAdmin.USER_FILTER.CLEAR_FILTER_BY_VALUE:
      return { ...state, filterByValue: '' };
    case Constants.SuperAdmin.SELECTOR_ACTION_TYPES.SELECT_TOOL:
      return { ...state, filterByValue: '' };
    default:
      return state;
  }
}
